<template>
    <div>
        <!-- 搜索区域 -->
        <el-form :inline="true" :model="queryParams" class="demo-form-inline" size="small" style="text-align: left; margin-top: 5px">
            <el-form-item label="学校选择">
                <el-select v-model="queryParams.schoolId" placeholder="请选择学校" :clearable="!schoolLocked" filterable :disabled="schoolLocked" @change="handleSchoolChange">
                    <el-option
                            v-for="item in schoolList"
                            :key="item.schoolId"
                            :label="item.schoolName"
                            :value="item.schoolId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="getBannerList()">查询</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery()">重置</el-button>
            </el-form-item>
        </el-form>

        <!-- 操作按钮 -->
        <el-row :gutter="10" class="mb8">
            <el-col :span="1.5">
                <el-button
                        type="primary"
                        plain
                        icon="el-icon-plus"
                        size="mini"
                        @click="addBanner()"
                        :disabled="!queryParams.schoolId"
                >添加轮播图</el-button>
            </el-col>
        </el-row>

        <!-- 轮播图表格 -->
        <el-table
                :data="bannerList"
                style="width: 100%; margin-bottom: 20px; line-height: 0"
                row-key="id"
                show-header
                border>
            <el-table-column label="轮播图" align="center" width="200">
                <template slot-scope="scope">
                    <el-image
                            style="width: 160px; height: 80px; border-radius: 8px;"
                            :src="scope.row.imageUrl"
                            fit="cover"
                            :preview-src-list="[scope.row.imageUrl]">
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column label="标题" align="center" prop="title" :show-overflow-tooltip="true" />
            <el-table-column label="跳转链接" align="center" prop="linkUrl" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span v-if="scope.row.linkUrl">{{ scope.row.linkUrl }}</span>
                    <span v-else style="color: #909399">无</span>
                </template>
            </el-table-column>
            <el-table-column label="链接类型" align="center" width="100">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.linkType === 1" size="small">内部页面</el-tag>
                    <el-tag v-else-if="scope.row.linkType === 2" size="small" type="warning">外部链接</el-tag>
                    <span v-else>-</span>
                </template>
            </el-table-column>
            <el-table-column label="排序" align="center" prop="sort" width="80" sortable />
            <el-table-column label="状态" align="center" width="100">
                <template slot-scope="scope">
                    <el-switch
                            v-model="scope.row.status"
                            :active-value="1"
                            :inactive-value="0"
                            @change="handleStatusChange(scope.row)"
                            active-text="启用"
                            inactive-text="禁用">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column label="展示时间" align="center" width="200">
                <template slot-scope="scope">
                    <span v-if="scope.row.startTime || scope.row.endTime">
                        {{ scope.row.startTime | dateFormat }} ~ {{ scope.row.endTime | dateFormat }}
                    </span>
                    <span v-else style="color: #909399">长期展示</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button
                            size="mini"
                            type="text"
                            icon="el-icon-edit"
                            @click="editBanner(scope.row)"
                    >编辑</el-button>
                    <el-button
                            size="mini"
                            type="text"
                            icon="el-icon-delete"
                            style="color: #f56c6c"
                            @click="deleteBanner(scope.row)"
                    >删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
                v-if="bannerList.length > 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryParams.pageNum"
                :page-sizes="[5, 10, 20, 50]"
                :page-size="queryParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
        </el-pagination>

        <!-- 添加/编辑轮播图对话框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogOpen" width="600px" append-to-body destroy-on-close>
            <el-form ref="bannerForm" :model="bannerForm" :rules="rules" label-width="100px">
                <el-form-item label="学校" prop="schoolId">
                    <el-select v-model="bannerForm.schoolId" placeholder="请选择学校" filterable :disabled="!!bannerForm.id || schoolLocked">
                        <el-option
                                v-for="item in schoolList"
                                :key="item.schoolId"
                                :label="item.schoolName"
                                :value="item.schoolId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标题" prop="title">
                    <el-input v-model="bannerForm.title" placeholder="请输入轮播图标题" maxlength="50" />
                </el-form-item>
                <el-form-item label="轮播图" prop="imageUrl">
                    <div class="upload-container">
                        <el-input v-model="bannerForm.imageUrl" placeholder="请上传轮播图" readonly style="margin-bottom: 10px" />
                        <el-upload
                                class="avatar-uploader"
                                action="#"
                                :http-request="handleUpload"
                                :show-file-list="false"
                                :before-upload="beforeUpload"
                                accept="image/*">
                            <img v-if="bannerForm.imageUrl" :src="bannerForm.imageUrl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </div>
                </el-form-item>
                <el-form-item label="链接类型" prop="linkType">
                    <el-radio-group v-model="bannerForm.linkType">
                        <el-radio :label="1">内部页面</el-radio>
                        <el-radio :label="2">外部链接</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="跳转链接" prop="linkUrl">
                    <el-input v-model="bannerForm.linkUrl" :placeholder="bannerForm.linkType === 1 ? '请输入小程序页面路径，如 /pages/index/index' : '请输入外部URL'" />
                    <div style="color: #909399; font-size: 12px; margin-top: 5px">
                        <span v-if="bannerForm.linkType === 1">示例：/pages/index/index</span>
                        <span v-else>示例：https://www.example.com</span>
                    </div>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input-number v-model="bannerForm.sort" :min="0" :max="9999" />
                    <span style="color: #909399; margin-left: 10px">数字越小越靠前</span>
                </el-form-item>
                <el-form-item label="展示时间">
                    <el-date-picker
                            v-model="dateRange"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            style="width: 100%">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogOpen = false">取 消</el-button>
                <el-button type="primary" @click="submitBanner" :loading="submitLoading">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { isSchoolScoped, getBoundSchoolId, lockSchoolOptions } from '@/utils/schoolScope'
export default {
    name: "BannerManagement",
    computed: {
        schoolLocked() {
            return isSchoolScoped();
        }
    },
    data() {
        return {
            // 学校列表
            schoolList: [],
            // 轮播图列表
            bannerList: [],
            // 查询参数
            queryParams: {
                schoolId: null,
                pageNum: 1,
                pageSize: 10
            },
            // 总记录数
            total: 0,
            // 对话框标题
            dialogTitle: '',
            // 对话框是否显示
            dialogOpen: false,
            // 提交loading
            submitLoading: false,
            // 日期范围
            dateRange: [],
            // 表单数据
            bannerForm: {
                id: null,
                schoolId: null,
                title: '',
                imageUrl: '',
                linkUrl: '',
                linkType: 1,
                sort: 0,
                startTime: null,
                endTime: null
            },
            // 表单校验规则
            rules: {
                schoolId: [
                    { required: true, message: '请选择学校', trigger: 'change' }
                ],
                title: [
                    { required: true, message: '请输入标题', trigger: 'blur' },
                    { max: 50, message: '标题最多50个字符', trigger: 'blur' }
                ],
                imageUrl: [
                    { required: true, message: '请上传轮播图', trigger: 'change' }
                ]
            }
        }
    },
    created() {
        this.getSchoolList();
    },
    filters: {
        dateFormat(date) {
            if (!date) return '';
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            const hour = String(d.getHours()).padStart(2, '0');
            const minute = String(d.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day} ${hour}:${minute}`;
        }
    },
    methods: {
        // 获取学校列表
        async getSchoolList() {
            try {
                const res = await this.$http.get('/school/AppGetCampusSchoolList');
                if (res.data.code === 200) {
                    this.schoolList = lockSchoolOptions(res.data.data || []);
                    if (isSchoolScoped() && getBoundSchoolId() != null) {
                        this.queryParams.schoolId = getBoundSchoolId();
                        this.getBannerList();
                    }
                }
            } catch (error) {
                console.error('获取学校列表失败', error);
            }
        },
        // 获取轮播图列表
        async getBannerList() {
            if (!this.queryParams.schoolId) {
                this.$message.warning('请先选择学校');
                return;
            }
            try {
                const res = await this.$http.get('/banner/admin/getAllBanners', {
                    params: { schoolId: this.queryParams.schoolId }
                });
                if (res.data.code === 200) {
                    this.bannerList = res.data.data || [];
                    this.total = this.bannerList.length;
                } else {
                    this.$message.error(res.data.msg || '获取轮播图列表失败');
                }
            } catch (error) {
                console.error('获取轮播图列表失败', error);
                this.$message.error('获取轮播图列表失败');
            }
        },
        // 学校选择变化
        handleSchoolChange() {
            this.bannerList = [];
            if (this.queryParams.schoolId) {
                this.getBannerList();
            }
        },
        // 重置查询
        resetQuery() {
            this.queryParams.schoolId = isSchoolScoped() ? getBoundSchoolId() : null;
            this.bannerList = [];
            this.total = 0;
            if (this.queryParams.schoolId) {
                this.getBannerList();
            }
        },
        // 添加轮播图
        addBanner() {
            this.dialogTitle = '添加轮播图';
            this.bannerForm = {
                id: null,
                schoolId: this.queryParams.schoolId,
                title: '',
                imageUrl: '',
                linkUrl: '',
                linkType: 1,
                sort: 0,
                startTime: null,
                endTime: null
            };
            this.dateRange = [];
            this.dialogOpen = true;
        },
        // 编辑轮播图
        editBanner(row) {
            this.dialogTitle = '编辑轮播图';
            this.bannerForm = {
                id: row.id,
                schoolId: row.schoolId,
                title: row.title || '',
                imageUrl: row.imageUrl || '',
                linkUrl: row.linkUrl || '',
                linkType: row.linkType || 1,
                sort: row.sort || 0
            };
            if (row.startTime || row.endTime) {
                this.dateRange = [row.startTime, row.endTime];
            } else {
                this.dateRange = [];
            }
            this.dialogOpen = true;
        },
        // 提交轮播图
        async submitBanner() {
            this.$refs.bannerForm.validate(async valid => {
                if (!valid) return;

                this.submitLoading = true;
                try {
                    // 处理时间范围
                    if (this.dateRange && this.dateRange.length === 2) {
                        this.bannerForm.startTime = this.dateRange[0];
                        this.bannerForm.endTime = this.dateRange[1];
                    } else {
                        this.bannerForm.startTime = null;
                        this.bannerForm.endTime = null;
                    }

                    const url = this.bannerForm.id ? '/banner/admin/updateBanner' : '/banner/admin/addBanner';
                    const res = await this.$http.post(url, this.bannerForm);

                    if (res.data.code === 200) {
                        this.$message.success(this.bannerForm.id ? '修改成功' : '添加成功');
                        this.dialogOpen = false;
                        this.getBannerList();
                    } else {
                        this.$message.error(res.data.msg || '操作失败');
                    }
                } catch (error) {
                    console.error('提交轮播图失败', error);
                    this.$message.error('操作失败');
                } finally {
                    this.submitLoading = false;
                }
            });
        },
        // 上传前校验（与后端 spring.servlet.multipart.max-file-size=2MB 对齐）
        beforeUpload(file) {
            const isImage = file.type.startsWith('image/');
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isImage) {
                this.$message.error('只能上传图片文件!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('图片大小不能超过 2MB!');
                return false;
            }
            return true;
        },
        // 上传图片：复用后端已有 POST /upload（OssController），不要手写 Content-Type，否则会丢掉 multipart boundary
        async handleUpload(param) {
            const formData = new FormData();
            formData.append('file', param.file);

            try {
                const res = await this.$http.post('/upload', formData);
                if (res.data.code === 200) {
                    this.bannerForm.imageUrl = res.data.data;
                    this.$message.success('上传成功');
                } else {
                    this.$message.error(res.data.msg || '上传失败');
                }
            } catch (error) {
                console.error('上传图片失败', error);
                this.$message.error('上传失败');
            }
        },
        // 删除轮播图
        deleteBanner(row) {
            this.$confirm('确认删除轮播图 "' + (row.title || '未命名') + '" 吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const res = await this.$http.post('/banner/admin/deleteBanner', null, {
                        params: { id: row.id }
                    });
                    if (res.data.code === 200) {
                        this.$message.success('删除成功');
                        this.getBannerList();
                    } else {
                        this.$message.error(res.data.msg || '删除失败');
                    }
                } catch (error) {
                    console.error('删除轮播图失败', error);
                    this.$message.error('删除失败');
                }
            }).catch(() => {});
        },
        // 切换状态
        async handleStatusChange(row) {
            try {
                const res = await this.$http.post('/banner/admin/updateStatus', null, {
                    params: { id: row.id, status: row.status }
                });
                if (res.data.code === 200) {
                    this.$message.success(row.status === 1 ? '已启用' : '已禁用');
                } else {
                    // 恢复原状态
                    row.status = row.status === 1 ? 0 : 1;
                    this.$message.error(res.data.msg || '操作失败');
                }
            } catch (error) {
                // 恢复原状态
                row.status = row.status === 1 ? 0 : 1;
                console.error('切换状态失败', error);
                this.$message.error('操作失败');
            }
        },
        // 分页大小变化
        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.getBannerList();
        },
        // 页码变化
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.getBannerList();
        }
    }
}
</script>

<style scoped>
.mb8 {
    margin-bottom: 8px;
}
.upload-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: var(--primary-color);
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 120px;
    line-height: 120px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 120px;
    display: block;
}
</style>
